import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { rvApi } from '../api';
import { ROUTES } from '../../../constants/routes';

function RulesViolationAdmin() {
  const [groups, setGroups] = useState([]);
  const [types, setTypes] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [groupForm, setGroupForm] = useState({ key: '', name: '', sortOrder: 0 });
  const [typeForm, setTypeForm] = useState({ name: '', sortOrder: 0 });
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const loadGroups = async () => {
    const res = await rvApi.adminGroups();
    setGroups(res.data);
    if (!selectedGroupId && res.data.length) setSelectedGroupId(String(res.data[0].id));
  };

  const loadTypes = async (gid) => {
    if (!gid) return setTypes([]);
    const res = await rvApi.adminTypes(gid);
    setTypes(res.data);
  };

  useEffect(() => {
    loadGroups().catch((e) => setError(e.response?.data?.error || 'Load failed'));
  }, []);

  useEffect(() => {
    if (selectedGroupId) loadTypes(selectedGroupId).catch(() => setTypes([]));
  }, [selectedGroupId]);

  const saveGroup = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await rvApi.adminCreateGroup(groupForm);
      setGroupForm({ key: '', name: '', sortOrder: 0 });
      setMsg('Group created');
      await loadGroups();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed');
    }
  };

  const saveType = async (e) => {
    e.preventDefault();
    if (!selectedGroupId) return;
    setError('');
    try {
      await rvApi.adminCreateType({ groupId: Number(selectedGroupId), ...typeForm });
      setTypeForm({ name: '', sortOrder: 0 });
      setMsg('Type created');
      await loadTypes(selectedGroupId);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed');
    }
  };

  const toggleGroup = async (g) => {
    await rvApi.adminUpdateGroup(g.id, { isActive: !g.is_active });
    await loadGroups();
  };

  const toggleType = async (t) => {
    await rvApi.adminUpdateType(t.id, { isActive: !t.is_active });
    await loadTypes(selectedGroupId);
  };

  return (
    <div>
      <h2 className="h4 mb-3">Rules Violation admin</h2>
      <p className="text-muted small mb-3">
        Property staff (CM, assistant manager, RVP) is managed in{' '}
        <Link to={ROUTES.HOME_ADMIN}>Compass Home Admin</Link> → Property staff.
      </p>
      {error && <div className="alert alert-danger">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="row g-4">
        <div className="col-lg-5">
          <h5>Groups</h5>
          <table className="table table-sm">
            <thead><tr><th>Name</th><th>Key</th><th>Active</th></tr></thead>
            <tbody>
              {groups.map((g) => (
                <tr key={g.id} className={String(g.id) === selectedGroupId ? 'table-primary' : ''} style={{ cursor: 'pointer' }} onClick={() => setSelectedGroupId(String(g.id))}>
                  <td>{g.name}</td>
                  <td className="small">{g.key}</td>
                  <td>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => { e.stopPropagation(); toggleGroup(g); }}>
                      {g.is_active ? 'Yes' : 'No'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <form className="card card-body mt-2" onSubmit={saveGroup}>
            <h6 className="mb-2">Add group</h6>
            <input className="form-control form-control-sm mb-2" placeholder="key (snake_case)" value={groupForm.key} onChange={(e) => setGroupForm({ ...groupForm, key: e.target.value })} required />
            <input className="form-control form-control-sm mb-2" placeholder="Display name" value={groupForm.name} onChange={(e) => setGroupForm({ ...groupForm, name: e.target.value })} required />
            <button type="submit" className="btn btn-sm btn-primary">Add group</button>
          </form>
        </div>
        <div className="col-lg-7">
          <h5>Violation types</h5>
          <table className="table table-sm">
            <thead><tr><th>Name</th><th>Order</th><th>Active</th></tr></thead>
            <tbody>
              {types.map((t) => (
                <tr key={t.id}>
                  <td>{t.name}</td>
                  <td>{t.sort_order}</td>
                  <td>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => toggleType(t)}>
                      {t.is_active ? 'Yes' : 'No'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <form className="card card-body mt-2" onSubmit={saveType}>
            <h6 className="mb-2">Add violation type</h6>
            <input className="form-control form-control-sm mb-2" placeholder="Name" value={typeForm.name} onChange={(e) => setTypeForm({ ...typeForm, name: e.target.value })} required />
            <button type="submit" className="btn btn-sm btn-primary" disabled={!selectedGroupId}>Add type</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RulesViolationAdmin;
